<template>
  <div>
    <div v-if="obj" class="d-flex flex-row">
      <favorite-toggler :codeObj="obj"></favorite-toggler>

      <router-link
        v-if="makeLink && !isChapterOrSection && obj.descendants != '0'"
        :to="'/icd10/' + theKey"
      >
        <span :class="nameClass" v-html="title" class="font-weight-medium">
        </span>
        <span class="caption">&nbsp;&nbsp;({{ obj.descendants }})</span>
        <div v-if="obj.moreNotes" class="ml-4 green--text text--darken-1">
          ({{ obj.moreNotes }})
        </div>
      </router-link>
      <span v-else-if="sevenChar && obj.descendants == '0'">
        <code-with-7
          :label="obj.name"
          :sevenChar="localSevenChar"
          :code="obj.code"
        ></code-with-7>
      </span>
      <span v-else v-html="title" class="font-weight-medium"> </span>
      <notes-dialog
        v-if="obj.notes"
        :notes="obj.notes"
        :title="obj.name"
        :sevenChar="localSevenChar"
      >
      </notes-dialog>
      <add-alias :code="obj.code" :name="obj.name"></add-alias>
      <!-- <v-img
        v-if="imageForCode"
        :src="imgPath + imageForCode"
        class="mx-2 float-right"
        max-width="100px"
        max-height="80px"
      /> -->
    </div>
    <span v-if="localSevenChar && obj.descendants == '0' && !sevenChar">
      <div class="ml-2 grayBkg d-inline-block">
        <code-with-7
          label=" "
          :sevenChar="localSevenChar"
          :code="obj.code"
        ></code-with-7>
      </div>
    </span>
  </div>
</template>

<script>
import FormatIcdMixin from "@/assets/js/icd/FormatIcdMixin";
import AddAlias from "./AddAlias.vue";
export default {
  name: "IcdItem",
  components: {
    NotesDialog: () => import("@/components/icdStuff/NotesDialog"),
    CodeWith7: () => import("@/components/icdStuff/CodeWith7"),
    FavoriteToggler: () => import("@/components/icdStuff/FavoriteToggler"),
    AddAlias,
  },
  mixins: [FormatIcdMixin],
  props: {
    theKey: null,
    meta: null,
    codes: null,
    makeLink: { Type: Boolean, default: false },
    sevenChar: null,
    // specificCodesBtn: { type: Boolean, default: false },
  },
  data: function () {
    return {
      showSpecifics: false,
      // imgPath: "https://www.eyedock.com/images",
    };
  },
  methods: {
    // toggleSpecificCodes() {
    //   this.showSpecifics = !this.showSpecifics;
    //   this.$emit("showSpecifics", this.showSpecifics);
    // },
    chapterOrSectionObject(k) {
      let typeKey = this.itemType + "s"; // "chapters" or "sections"
      let num = k.replace(/^\D+[ ]/g, ""); // "Chapter 7" => "7"
      let obj = this.meta[typeKey][num];
      return obj;
    },
  },
  computed: {
    itemType: function () {
      // "item", "chapter", "section"

      let type = "item";
      let k = this.theKey;
      if (k.includes("chapter")) type = "chapter";
      if (k.includes("section")) type = "section";
      return type;
    },
    localSevenChar: function () {
      let rtn = this.sevenChar;
      if (this.obj.sevenChar) rtn = this.obj.sevenChar;
      return rtn;
    },
    nameClass: function () {
      let rtn = this.itemType;
      if (rtn == "item") {
        rtn = "level" + this.obj.level;
      }
      return rtn + "Class";
    },
    obj: function () {
      if (!this.theKey) return null;
      let obj = null;
      let k = this.theKey;
      // let t = this.itemType;
      if (this.isChapterOrSection) {
        obj = this.chapterOrSectionObject(k);
      } else {
        obj = this.codes[k];
      }
      return obj;
    },
    isChapterOrSection: function () {
      let t = this.itemType;
      return t == "chapter" || t == "section";
    },
    hasChildren: function () {
      return this.obj.children > 0;
    },
    // lastDigit: function () {
    //   let level = this.obj.level;
    //   let field = "c" + level;
    //   return this.obj[field];
    // },
    title: function () {
      let rtn = "";
      let obj = this.obj;
      let pre = "";
      if (this.itemType == "item") pre = this.theKey + " ";
      if (obj.name) rtn = obj.name;
      if (obj.shortName && !this.hasChildren && obj.level > 5)
        rtn = obj.shortName;
      if (!this.makeLink) rtn = this.simplifyLaterality(rtn); // from FormatIcdMixin
      return pre + rtn;
    },
    // imageForCode: function () {
    //   return this.meta?.images?.[this.theKey];
    // },
  },
  watch: {
    theKey: function (val) {
      this.setType(val);
      //   this.setObj();
    },
  },
};
</script>

<style scoped>
.chapterClass {
  font-size: 17pt;
  background-color: #fee2b6;
  padding: 3px 6px;
  border-radius: 3px;
}
.sectionClass {
  font-size: 16pt;
  text-decoration: underline;
}
.level3Class {
  font-size: 15pt;
}
.level4Class {
  font-size: 13pt;
}
.level5Class {
  font-size: 12pt;
}
.level6Class {
  font-size: 12pt;
}

.blueText {
  color: blue;
  font-weight: bold;
}
.greenText {
  color: green;
  font-weight: bold;
}
.grayBkg {
  background-color: #f1f1f1;
}

/*
	.moreNotesClass {
  color: green;
}
*/
</style>
